import { LoadingButton } from '@mui/lab'
import { Breakpoint, Stack } from '@mui/material'
import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import Divider from '@mui/material/Divider'
import Slide from '@mui/material/Slide'
import { TransitionProps } from '@mui/material/transitions'
import React from 'react'

const Transition = React.forwardRef(function Transition(
  props: TransitionProps & {
    children: any
  },
  ref: React.Ref<unknown>
) {
  return <Slide direction="down" ref={ref} {...props} />
})

interface Props {
  open: boolean
  title?: string
  primaryButton?: boolean
  primaryButtonText?: string
  loading?: boolean
  maxWidth?: Breakpoint
  disabled?: boolean
  bodyMinHeight?: number
  primaryButtonColor?:
    | 'inherit'
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning'
  component?: React.ElementType<any>
  handleClose: () => void
  handleSubmit?: () => void
  children?: string | JSX.Element | JSX.Element[] | any
}

export default function DialogConfirm({
  open,
  loading,
  title = '',
  maxWidth = 'sm',
  primaryButton = true,
  primaryButtonText = '実施する',
  children,
  primaryButtonColor = 'primary',
  component = 'div',
  disabled = false,
  bodyMinHeight = 120,
  handleClose,
  handleSubmit,
}: Props) {
  return (
    <>
      <Dialog
        open={open}
        TransitionComponent={Transition}
        fullWidth
        maxWidth={maxWidth}
        onClose={(_e, reason) => {
          if (reason !== 'backdropClick') {
            handleClose()
          }
        }}
        sx={{
          '& .MuiPaper-root': {
            opacity: 0.98,
          },
          '& .MuiDialogContent-root': {
            px: 1,
            py: 0.5,
          },
        }}
      >
        <Stack component={component} spacing={1}>
          <DialogTitle sx={{ fontWeight: 'bold', py: 0.5 }}>
            {title}
          </DialogTitle>
          <Divider sx={{ mt: '0 !important' }} />
          <DialogContent
            sx={{
              minHeight: bodyMinHeight,
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'center',
            }}
          >
            {children}
          </DialogContent>
          <Divider />
          <DialogActions>
            <Stack
              width="100%"
              direction="row"
              justifyContent="space-around"
              alignItems="center"
              mb={1}
            >
              <LoadingButton
                loading={loading}
                variant="outlined"
                color="inherit"
                size="small"
                sx={{
                  width: 100,
                }}
                onClick={() => handleClose()}
              >
                閉じる
              </LoadingButton>
              {primaryButton && (
                <LoadingButton
                  loading={loading}
                  variant="contained"
                  color={primaryButtonColor}
                  disabled={disabled}
                  size="small"
                  type={component === 'form' ? 'submit' : 'button'}
                  sx={{
                    minWidth: 100,
                  }}
                  onClick={() => {
                    handleSubmit && handleSubmit()
                  }}
                >
                  {primaryButtonText}
                </LoadingButton>
              )}
            </Stack>
          </DialogActions>
        </Stack>
      </Dialog>
    </>
  )
}
